module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/teachers/malgorzata-lesinska-707909bccc5ed45ff2a79130e50df316.png";